import contentTypes from '@/utils/constants/contentTypes.js';

export default {
  //The documentFile param has the DocumentDTO squema
  Download(documentFile) {
    const byteChars = atob(documentFile.content);
    const byteNumbers = new Array(byteChars.length);
    for (let i = 0; i < byteChars.length; i++) {
      byteNumbers[i] = byteChars.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);

    let blob = new Blob([byteArray], {
      type: documentFile.contentType,
    });
    let link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = documentFile.filename;
    link.click();
  },
  DownloadFile(
    data,
    fileName = 'file',
    headers = {},
    contentType = contentTypes.excel
  ) {
    const finalContentType = headers['content-type'] || contentType;
    const blob = new Blob([data], { type: finalContentType });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;

    const finalFileName = headers['x-file-name'] || fileName;
    link.setAttribute('download', finalFileName);

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  },
};
